import { Badge, IconButton } from '@mui/material';
import ShoppingCartOutlined from '@mui/icons-material/ShoppingCartOutlined';
import { useUserState } from 'context/User';
import { UserStateContextType } from 'components/constants/Constants';
import { useCartState } from '../contexts/cart/CartContext';
import { useLocation } from 'react-router-dom';
import { UXB_ROUTE_NAMES } from '../UXBRouteNames';

export const CartButton: React.FC = () => {
  const userState = useUserState();
  const {
    value: { items },
    setDrawerOpen
  } = useCartState();
  const location = useLocation();
  const changeDrawerState = () => {
    !location.pathname.includes(UXB_ROUTE_NAMES.cart) && setDrawerOpen(true);
  };

  return userState.type !== UserStateContextType.AUTHENTICATED ? null : (
    <IconButton onClick={() => changeDrawerState()} color="primary">
      <Badge badgeContent={items.length} color="primary">
        <ShoppingCartOutlined />
      </Badge>
    </IconButton>
  );
};
